<template>
  <div>
    <v-row>
      <v-col cols="12">
        <h2 class="mt-4">SEO</h2>
      </v-col>
      <v-col cols="12" sm="4">
        <app-input
          data-testid="seo-facility-slug-input"
          class="seo-facility-slug-input"
          :type="'text'"
          v-model="currentFacility.slug"
          label="Facility URL"
          hint="Leave this blank if you want to use the default structure"
          :rules="{ required: true }"
          :useValidation="true"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <app-input
          data-testid="seo-facility-meta-title-input"
          class="seo-facility-meta-title-input"
          :type="'text'"
          v-model="currentFacility.meta_title"
          label="Page Title"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <app-input
          data-testid="seo-facility-meta-description-input"
          class="seo-facility-meta-description-input"
          :type="'text'"
          v-model="currentFacility.meta_description"
          label="Meta: Description"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <app-input
          data-testid="seo-facility-meta-keywords-input"
          class="seo-facility-meta-keywords-input"
          :type="'text'"
          v-model="currentFacility.meta_keywords"
          label="Meta: Keywords"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h2>Facility Promotion</h2>
      </v-col>
      <v-col cols="12">
        <v-switch
          data-testid="seo-facility-display-promo-switch"
          class="seo-facility-display-promo-switch"
          v-model="currentFacility.promotion_enabled"
          label="Promotion Display Enabled"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-if="currentFacility.promotion_enabled"
        cols="12"
        sm="8"
      >
        <app-input
          data-testid="seo-facility-promo-text-input"
          class="seo-facility-promo-text-input"
          :type="'text'"
          v-model="currentFacility.promotion_text"
          label="Promotion Text"
          hint="This text will be used for the alt tag on the image, as well as the hover text when a user hovers over
           the image"
        />
      </v-col>
    </v-row>

    <v-row
      v-if="shouldShowPromoImages()"
      align="center"
    >
      <v-col cols="6">
        <v-row v-if="!currentFacility.promotion_image">
          <v-col cols="12">
            <h3>Large Image</h3>
          </v-col>
          <v-col cols="12">
            <AddPhoto
              data-testid="seo-facility-promo-img-add-btn"
              class="seo-facility-promo-img-add-btn"
              dispatchMethod="uploadFacilityPromotionImage"
              :additionalData="lrgExtra"
            />
          </v-col>
        </v-row>
        <v-row v-if="currentFacility.promotion_image">
          <v-col cols="12">
            <v-img
              width="1140"
              height="100"
              v-if="currentFacility.promotion_image"
              :src="imageBasePath + currentFacility.promotion_image.url"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <v-btn
              data-testid="seo-facility-promo-img-delete-btn"
              class="seo-facility-promo-img-delete-btn my-3"
              v-if="currentFacility.promotion_image"
              color="error"
              small
              block
              @click="openDelete('promo image')"
            >
              Delete
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="shouldShowPromoImages()" align="center">
      <v-col cols="6">
        <v-row v-if="!currentFacility.promotion_mobile_image">
          <v-col cols="12">
            <h3>Mobile Image</h3>
          </v-col>
          <v-col cols="12">
            <AddPhoto
              data-testid="seo-facility-mobile-img-add-btn"
              class="seo-facility-mobile-img-add-btn"
              dispatchMethod="uploadFacilityPromotionImage"
              :additionalData="smExtra"
            />
          </v-col>
        </v-row>
        <v-row v-if="currentFacility.promotion_mobile_image">
          <v-col cols="12">
            <v-img
              width="450"
              height="150"
              v-if="currentFacility.promotion_mobile_image"
              :src="imageBasePath + currentFacility.promotion_mobile_image.url"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <v-btn
              data-testid="seo-facility-mobile-img-delete-btn"
              class="seo-facility-mobile-img-delete-btn my-3"
              v-if="currentFacility.promotion_mobile_image"
              color="error"
              small
              block
              @click="openDelete('promo mobile image')"
            >
              Delete
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h2 class="mt-4">Facility Open Graph Image</h2>
      </v-col>
      <v-col
        v-if="currentFacility.og_image && currentFacility.og_image.url"
        cols="6"
        sm="4"
        md="3"
        lg="2"
      >
        <v-img
          :src="imageBasePath + currentFacility.og_image.url"
          aspect-ratio="1"
        >
          <v-row
            class="fill-height ma-0"
            slot="placeholder"
            align="center"
            justify="center"
          >
            <v-progress-circular indeterminate color="grey" />
          </v-row>
        </v-img>
        <v-btn
          data-testid="seo-facility-og-img-delete-btn"
          class="seo-facility-og-img-delete-btn my-3"
          @click="openDelete('og image')"
          color="error"
          small
          block
        >
          Delete
        </v-btn>
      </v-col>
      <v-col
        cols="4"
        sm="3"
        lg="2"
        v-else
      >
          <add-photo
            data-testid="seo-facility-og-img-add-btn"
            class="seo-facility-og-img-add-btn"
            dispatchMethod="updateOgImage"
          />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h2>Rent Online</h2>
      </v-col>
      <v-col cols="6" sm="4">
        <v-switch
          data-testid="seo-facility-ro-enable-switch"
          class="seo-facility-ro-enable-switch"
          v-model="currentFacility.ro_enabled"
          :label="`Rent Online ${currentFacility.ro_enabled ? 'Enabled' : 'Disabled'}`"
        />
      </v-col>
      <v-col
        cols="6"
        sm="4"
        v-if="currentFacility.ro_enabled"
      >
        <v-switch
          data-testid="seo-facility-upsell-enable-switch"
          class="seo-facility-upsell-enable-switch"
          v-model="currentFacility.ro_tpp_upsell_enabled"
          :label="`TPP Upsell ${currentFacility.ro_tpp_upsell_enabled ? 'Enabled' : 'Disabled'}`"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-inline-flex">
        <h2 class="d-inline">U-Haul Banners</h2>
        <v-switch
          data-testid="seo-facility-uhaul-enable-switch"
          class="seo-facility-uhaul-enable-switch d-inline ml-6 mt-0 pt-2"
          v-model="currentFacility.uhaul_enabled"
          :label="`U-Haul ${currentFacility.uhaul_enabled ? 'Enabled' : 'Disabled'}`"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <app-input
          data-testid="seo-facility-uhaul-url-input"
          class="seo-facility-uhaul-url-input"
          :type="'text'"
          v-if="currentFacility.uhaul_enabled"
          v-model="currentFacility.uhaul_link"
          label="Link to U-Haul website"
          hint="This should be a link directly to the facility page on the U-Haul website"
          persistent-hint
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h2>Virtual Tour Link</h2>
      </v-col>
      <v-col cols="6">
        <app-input
          data-testid="seo-facility-virtual-tour-url-input"
          class="seo-facility-virtual-tour-url-input"
          v-model="currentFacility.virtual_tour_link"
          label="Link to Google Maps Virtual Tour"
          hint="This should be a link directly to the facility's Google Maps virtual tour"
          persistent-hint
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h2>Other Options</h2>
      </v-col>
      <v-col cols="12" sm="4">
        <ValidationProvider
          rules="required"
          mode="eager"
          name="unitTypeOptions"
          v-slot="{ valid, errors, invalid, classes }"
        >
          <v-select
            data-testid="seo-facility-unit-type-menu"
            class="seo-facility-unit-type-menu"
            filled
            v-model="currentFacility.unit_type_sort_by"
            :items="unitTypeSortByOptions"
            label="Sort Units By"
            hint="Choose how units are sorted on the facility details page"
            persistent-hint
            clearable
            :class="classes"
            :error-messages="errors.length ? 'This field is required' : ''"
          />
        </ValidationProvider>
      </v-col>
      <v-col cols="12" sm="4">
        <app-input
          data-testid="seo-facility-directions-link-input"
          class="seo-facility-directions-link-input"
          v-model="currentFacility.directions_link"
          label="Directions Link"
          hint="Use this to provide users with a Google Maps link for directions to the facility"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <app-input
          data-testid="seo-facility-res-lead-max-input"
          class="seo-facility-res-lead-max-input"
          v-model="currentFacility.reservation_lead_max"
          label="Maximum Reservation/Rent Online Lead (Days)"
          hint="This is the maximum number of days in the future a reservation or online rental can be created for via
          the website"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <app-input
          data-testid="seo-facility-markup-pct-input"
          class="seo-facility-markup-pct-input"
          v-model="currentFacility.markup_percent"
          label="Markup Percent"
          hint="A unit's 'In-store' price will have be increased by this percent (for display purposes only)"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <app-input
          data-testid="seo-facility-gmb-location-name-input"
          class="seo-facility-pay-gmb-location-name-input"
          v-model="currentFacility.gmb_location_name"
          label="Google MyBusiness Location ID"
          hint="Adding this will enable the Google review star rating to display for the facility"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <app-input
          data-testid="seo-facility-unit-additional-promo-input"
          class="seo-facility-unit-additional-promo-input"
          v-model="currentFacility.unit_additional_promo"
          label="Additional Unit Promo"
          hint="Additional promotion text that displays below the main promotion for every unit on the page"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h2>Content</h2>
      </v-col>
      <v-col cols="12">
        <h3>About Facility</h3>
        <div class="froala-container mt-2">
          <froala-wrapper
            data-testid="seo-facility-froala-wrapper-textarea"
            class="seo-facility-froala-wrapper-textarea"
            :froalaConfig="froalaConfig"
            :currentFacility="currentFacility"
            :launchFroala="launchFroala"
            id="facility-about"
          />
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h3>Banner Text</h3>
        <v-textarea
          data-testid="seo-facility-banner-text-textarea"
          class="seo-facility-banner-text-textarea mt-2"
          v-model="currentFacility.banner_text"
          filled
          label="Banner Text"
          hint="Banner that displays at the top of the page"
          clearable
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h3>Banner Color</h3>
        <v-radio-group v-model="currentFacility.banner_class" row>
          <v-radio
            data-testid="seo-facility-banner-gray-radio"
            class="seo-facility-banner-gray-radio"
            label="Gray"
            color="#e2e3e5"
            value="alert-secondary"
          />
          <v-radio
            data-testid="seo-facility-banner-green-radio"
            class="seo-facility-banner-green-radio"
            label="Green"
            color="#d7f3e3"
            value="alert-success"
          />
          <v-radio
            data-testid="seo-facility-banner-yellow-radio"
            class="seo-facility-banner-yellow-radio"
            label="Yellow"
            color="#fffbdb"
            value="alert-warning"
          />
          <v-radio
            data-testid="seo-facility-banner-red-radio"
            class="seo-facility-banner-red-radio"
            label="Red"
            color="#f4cfd5"
            value="alert-danger"
          />
        </v-radio-group>
        <p class="mb-0">
          To preview banner colors
          <a
            href="https://getbootstrap.com/docs/4.3/components/alerts/"
            target="_blank"
          >
            click here
          </a>
        </p>
      </v-col>
    </v-row>
    <v-row class="mt-3">
      <v-col>
        <h3>BBB Seal</h3>
        <v-textarea
          data-testid="seo-facility-bbb-seal-textarea"
          class="seo-facility-bbb-seal-textarea mt-2"
          v-model="currentFacility.bbb_seal"
          label="Content"
          filled
          clearable
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h2>Custom Code</h2>
      </v-col>
      <v-col cols="12" sm="4">
        <v-textarea
          data-testid="seo-facility-markup-head-textarea"
          class="seo-facility-markup-head-textarea"
          v-model="currentFacility.custom_markup_head"
          filled
          label="Custom Markup (head)"
          hint="Code in this box will be injected right before the closing head tag on this page"
          clearable
        />
      </v-col>
      <v-col cols="12" sm="4">
        <v-textarea
          data-testid="seo-facility-markup-body-textarea"
          class="seo-facility-markup-body-textarea"
          v-model="currentFacility.custom_markup_body"
          filled
          label="Custom Markup (body)"
          hint="Code in this box will be injected right before the closing body tag on this page"
          clearable
        />
      </v-col>
      <v-col cols="12" sm="4">
        <v-textarea
          data-testid="seo-facility-custom-css-textarea"
          class="seo-facility-custom-css-textarea"
          v-model="currentFacility.custom_css"
          filled
          label="Custom CSS"
          clearable
        />
      </v-col>
    </v-row>

    <delete-modal
      v-model="modal"
      class="v-btn--block"
      @delete="deleteImage(itemToDelete)"
      :itemType="itemToDelete"
      :advisory="advisory"
    />
  </div>
</template>

<script>
import AddPhoto from "@/components/AddPhoto.vue";
import AppInput from "@/components/global/AppInput";
import DeleteModal from "@/components/DeleteModal.vue";
import FroalaWrapper from "@/views/facility/partials/FroalaWrapper.vue";
import { ValidationProvider } from "vee-validate";
import { genericAdvisory } from "@/helpers/warning-advisory-text";

export default {
  components: {
    AddPhoto,
    AppInput,
    DeleteModal,
    FroalaWrapper,
    ValidationProvider
  },
  props: {
    launchFroala: {
      type: Boolean
    }
  },
  data() {
    return {
      advisory: genericAdvisory,
      unitTypeSortByOptions: [
        {
          text: "Price",
          value: "price"
        },
        {
          text: "Sq. Ft.",
          value: "sqft"
        }
      ],
      imageBasePath: `${process.env.VUE_APP_PHOTO_BASE_PATH}/`,
      modal: false,
      itemToDelete: ""
    };
  },
  methods: {
    deleteImage(itemToDelete) {
      if (itemToDelete === "promo image") {
        return this.deletePromoImage();
      } else if (itemToDelete === "promo mobile image") {
        return this.deletePromoMobileImage();
      }
      return this.deleteOgImage();
    },

    deletePromoImage() {
      this.$store.dispatch("deleteImage", this.currentFacility.promotion_photo_url);
      this.$store.commit("clearPromoImage");
      this.modal = false;
    },

    deletePromoMobileImage() {
      this.$store.dispatch("deleteImage", this.currentFacility.promotion_mobile_photo_url);
      this.$store.commit("clearPromoMobileImage");
      this.modal = false;
    },

    deleteOgImage() {
      this.$store.dispatch("deleteImage", this.currentFacility.og_image.id);
      this.$store.commit("clearOgImage");
      this.modal = false;
    },

    openDelete(itemToDelete) {
      this.modal = true;
      this.itemToDelete = itemToDelete;
    },

    shouldShowPromoImages() {
      return this.currentFacility.promotion_enabled ||
        this.currentFacility.promotion_image ||
        this.currentFacility.promotion_mobile_image;
    }
  },
  computed: {
    currentFacility: {
      get() {
        return this.$store.state.facility.currentFacility;
      },
      set(newValue) {
        /* istanbul ignore next */
        this.$store.commit("setCurrentFacilityData", newValue);
      }
    },
    froalaConfig() {
      return {
        ...this.$store.state.app.froalaConfig,
        theme: this.$vuetify.theme.dark ? "dark" : null,
        requestHeaders: {
          Authorization: this.$store.state.auth.access_token
        }
      };
    },
    lrgExtra() {
      return {
        type: "large",
        promotion_enabled: this.$store.state.facility.currentFacility.promotion_enabled
      };
    },
    smExtra() {
      return {
        type: "mobile",
        promotion_enabled: this.$store.state.facility.currentFacility.promotion_enabled
      };
    }
  }
};
</script>

<style>
  .froala-container {
    position: relative;
    overflow: hidden;
  }
</style>
